module.exports = __webpack_public_path__ + "static/media/ced_logo.30fc2c05.png";